import { PageLayout } from '../components/Layout';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../components/ui/accordion';

const FAQ = () => {
  const faqs = [
    {
      question: "How long until I get a match?",
      answer: "Match timing varies based on your preferences and our current member pool. Our matchmakers work diligently to find quality matches, which typically takes 1-2 weeks. We believe in quality over speed, so we won't rush to make a subpar match."
    },
    {
      question: "What if I don't like my match?",
      answer: "No problem! After your video call, you'll provide feedback. If it's not a connection, simply indicate you'd like another match. There's no pressure and we'll continue searching for someone more compatible."
    },
    {
      question: "Is my data safe?",
      answer: "Absolutely. We take privacy seriously. Your profile information is only visible to our matchmaking team, never to other members. We use industry-standard encryption and never share or sell your personal data."
    },
    {
      question: "How do you match people?",
      answer: "Our experienced matchmakers review profiles personally, considering compatibility factors like interests, values, lifestyle and relationship goals. We combine human intuition with data insights to make thoughtful introductions."
    },
    {
      question: "Is the video call required?",
      answer: "Yes, video calls are a core part of our process. They provide a safe first introduction before any contact information is exchanged. The calls happen within our secure platform with safety features built in."
    },
    {
      question: "What happens after a successful video call?",
      answer: "After the call, both participants provide feedback. If both indicate mutual interest, we facilitate the exchange of contact information (email/phone). From there, you're free to continue getting to know each other on your own terms."
    },
    {
      question: "Can I see other profiles?",
      answer: "No. Unlike traditional dating apps, our members don't browse profiles. This is intentional—it reduces the 'shopping' mentality and ensures each introduction is meaningful and curated specifically for you."
    },
    {
      question: "How do I update my preferences?",
      answer: "You can update your profile and preferences anytime through your dashboard. If you've had a significant change in what you're looking for, let us know—it helps us make better matches."
    },
    {
      question: "Is there an age limit?",
      answer: "Members must be 21 or older. We welcome all adults who are serious about finding meaningful connections, regardless of age."
    },
    {
      question: "What if I feel unsafe during a call?",
      answer: "Your safety is our priority. Every video call has a 'Report & End Call' button that immediately terminates the call and alerts our moderation team. We take all reports seriously and investigate promptly."
    },
    {
      question: "Is this service free?",
      answer: "Link, Laugh & Love is a professional matchmaking service with packages designed to fit your needs. We offer a free consultation to discuss your goals, then you can choose the package that works best for you."
    },
    {
      question: "How do I contact support?",
      answer: "You can reach our team through your dashboard's help section or by emailing LinkLaughLoveMatch@gmail.com. We typically respond within 24 hours."
    }
  ];

  return (
    <PageLayout>
      {/* Hero */}
      <section className="py-24 md:py-32 bg-card">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="max-w-3xl">
            <span className="text-primary uppercase tracking-widest text-xs font-semibold">
              Support
            </span>
            <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl mt-4 mb-6 leading-tight">
              Frequently Asked Questions
            </h1>
            <p className="text-muted-foreground text-lg leading-relaxed">
              Find answers to common questions about Link, Laugh & Love's matchmaking service.
            </p>
          </div>
        </div>
      </section>

      {/* FAQ Accordion */}
      <section className="py-24 md:py-32">
        <div className="max-w-3xl mx-auto px-6 md:px-12">
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem 
                key={index} 
                value={`item-${index}`}
                className="paper-card rounded-sm px-6 border-none"
                data-testid={`faq-item-${index}`}
              >
                <AccordionTrigger className="text-left font-serif text-lg hover:no-underline py-6">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground pb-6 leading-relaxed">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>

      {/* Contact CTA */}
      <section className="py-24 md:py-32 bg-card">
        <div className="max-w-4xl mx-auto px-6 md:px-12 text-center">
          <h2 className="font-serif text-3xl md:text-4xl mb-6">
            Still Have Questions?
          </h2>
          <p className="text-muted-foreground text-lg mb-8">
            Our support team is here to help. Reach out anytime.
          </p>
          <a 
            href="mailto:LinkLaughLoveMatch@gmail.com"
            className="text-primary font-medium hover:underline text-lg"
          >
            LinkLaughLoveMatch@gmail.com
          </a>
        </div>
      </section>
    </PageLayout>
  );
};

export default FAQ;
